<template>
  <div class="list-full">
    <div id="info">
      <h1>{{ list.title }}</h1>

      <div v-if="isMine" id="list-status">
        <router-link :to="{ name: 'ListEdit', params: { id: list.id }}">Edit List</router-link>
      </div>

      <p class="user" v-if="list.user">a list of
        <span class="count">{{ list.entries.length }} album<span v-if="list.entries.length != 1">s</span></span>
        by
        <router-link :to="{ name: 'UserView', params: { username: list.user.username }}">{{ list.user.username }}</router-link>
      </p>
    </div>

    <div class="album" v-for="entry in list.entries" v-bind:key="entry.id">
      <img width="80px" height="80px" :src="entry.album.thumbnail" />

      <h2>
        <span class="title">{{ entry.album.title }}</span>
        <span class="artist">{{ entry.album.artist.name }}</span>
      </h2>

      <div class="controls">
        <button @click="playAlbum(entry.album)">PLAY</button>
      </div>
    </div>
  </div>
</template>

<script>
import ListsService from '@/services/ListsService'
export default {
  name: 'list',
  data () {
    return {
      list: {entries: []},
      isMine: false
    }
  },
  watch: {
    $route (to, from) {
      this.getList()
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getList () {
      ListsService.fetchList(this.$route.params.id)
        .then((response) => {
          this.list = response.data
          document.title = `${this.list.title} - an album list by ${this.list.user.username} - Long Player`
          this.isMine = this.$parent.user && (this.list.user.id === this.$parent.user.id)
        })
        .catch(() => {
          this.$router.push({ name: 'Home' })
        })
    },
    playAlbum (album) {
      this.$parent.playAlbum(album, this.list)
    }
  }
}
</script>
<style type="text/css">
  .list-full .album h2 {
    padding-left: 10px;
  }
  .list-full .album .controls {
    margin-left: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/List.vue